export const UPDATE_EVENT = 'organiser/UPDATE_EVENT'
export const UPDATE_STATS = 'organiser/UPDATE_STATS'
export const UPDATE_ORGANISERS = 'organiser/UPDATE_ORGANISERS'
export const UPDATE_TEAMS = 'organiser/UPDATE_TEAMS'
export const UPDATE_REGISTRATIONS = 'organiser/UPDATE_REGISTRATIONS'
export const UPDATE_PROJECTS = 'organiser/UPDATE_PROJECTS'
export const UPDATE_GAVEL_PROJECTS = 'organiser/UPDATE_GAVEL_PROJECTS'
export const UPDATE_GAVEL_ANNOTATORS = 'organiser/UPDATE_GAVEL_ANNOTATORS'
export const UPDATE_RANKINGS = 'organiser/UPDATE_RANKINGS'

export const REMOVE_ORGANISER = 'organiser/REMOVE_ORGANISER'

export const ADD_ORGANISER = 'organiser/ADD_ORGANISER'

export const EDIT_REGISTRATION = 'organiser/EDIT_REGISTRATION'
export const EDIT_EVENT = 'organiser/EDIT_EVENT'
export const EDIT_GAVEL_PROJECT = 'organiser/EDIT_GAVEL_PROJECT'
export const EDIT_GAVEL_ANNOTATOR = 'organiser/EDIT_GAVEL_ANNOTATOR'

export const UPDATE_FILTER_GROUPS = 'organiser/UPDATE_FILTER_GROUPS'
export const CREATE_FILTER_GROUP = 'organiser/CREATE_FILTER_GROUP'
export const EDIT_FILTER_GROUP = 'organiser/EDIT_FILTER_GROUP'
export const DELETE_FILTER_GROUP = 'organiser/DELETE_FILTER_GROUP'
